import { Url } from 'effect/unstable/http';
import { Data } from '../Data/index.js';
import { Result } from '../Result/index.js';
export const { mutate, setPathname, setSearch, setHash, setUsername, setPassword, setHost, setHostname, setPort, setProtocol, setHref, } = Url;
// eslint-disable-next-line
export class UrlError extends Data.TaggedError('UrlError') {
}
export const fromString = (string) => Result.try({
    try: () => new URL(string),
    catch: (cause) => new UrlError({ cause, from: string }),
});
//# sourceMappingURL=Url.js.map